import React, { createContext, useContext } from 'react';
import ContactModal from '../components/shared/ContactModal';
import useContactModal from '../hooks/useContactModal';

const ContactModalContext = createContext();

export const useContactModalContext = () => {
  const context = useContext(ContactModalContext);
  if (!context) {
    throw new Error('useContactModalContext deve ser usado dentro de ContactModalProvider');
  }
  return context;
};

export const ContactModalProvider = ({ children }) => {
  const { isModalOpen, openModal, closeModal, handleContactSubmit } = useContactModal();

  return (
    <ContactModalContext.Provider value={{ openModal }}>
      {children}
      <ContactModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onSubmit={handleContactSubmit}
      />
    </ContactModalContext.Provider>
  );
};

export default ContactModalContext; 